<mat-dialog-content cdkScrollable>
  <app-loading [type]="'spinner'" [value]="value" [showLoading]="showLoading"></app-loading>
  <div>
    <h1 *ngIf="isRead; else tplDemanda" class="itau-text-bold"> Demanda: {{ occurrenceForm.controls['id'].value }}</h1>
    <ng-template #tplDemanda>
      <h1 class="title itau-text-bold">adicionar nova demanda</h1>
    </ng-template>
  </div>
  <form #ngForm="ngForm" [formGroup]="occurrenceForm" (ngSubmit)="validateWallet(); onSubmit()"  >
    <div class="container" >
      <div class="occurence-types">
        <app-occurence-types [typesForm]="occurrenceForm.get('typesForm')" [ngForm]="ngForm"
          (newSelect)="listTypes($event)" [typesChecked]="instanceTypesChecked" (occurenceTypesChangeEvt)="occurenceTypesChange($event)" (manageDataFields)="enableDataFields($event);" [isVisualization]="isRead"></app-occurence-types>
      </div>
      <div class="separator">
        <mat-divider [vertical]="true" class="divider"></mat-divider>
      </div>
      <div class="occurence-data ">
        <app-occurence-data [dataForm]="occurrenceForm.get('dataForm')" [isVisualization]="isRead" [formWasSubmited]="ocurrenceWasSaved"></app-occurence-data>
        <app-occurence-dates [datesForm]="occurrenceForm.get('datesForm')" [ngForm]="ngForm"
          [typesSelectedList]="typesSelectedList" [occurenceTypes]="occurenceTypes" [selectedDates]="instanceTypesChecked" [isVisualization]="isRead"></app-occurence-dates>
        <app-occurence-attachments [filesSelected]="filesSelected" [filesForm]="occurrenceForm.get('filesForm')" [isVisualization]="isRead"></app-occurence-attachments>
        <app-occurence-description [occurrenceForm]="occurrenceForm"></app-occurence-description>
      <div *ngIf="isRead">
        <app-occurence-add-comments [occurrenceForm]="occurrenceForm" (newComment)="manageNewComment($event);" [commentsOccurrenceForm]="commentsOccurrenceForm"></app-occurence-add-comments>
        <div [hidden]="!showListComments" style="padding-top: 30px;">
          <app-occurence-list-comments [occurrenceId]="occurrenceId" [countComments]="matDialogData.hasComments"></app-occurence-list-comments>
        </div>
      </div>
      </div>
    </div>
    <div class="action-buttons-grid">
      <div *ngIf="!hasSubmitted">
        <div *ngIf="!isRead">
          <button type="button" mat-stroked-button class="cancel-button" (click)="closeModal()">cancelar</button>
          <button type="submit" mat-stroked-button class="sent-button">enviar</button>
        </div>
      </div>
      <div *ngIf="isRead || hasSubmitted">
        <button type="button" mat-stroked-button class="close-button" (click)="closeModal()">fechar</button>
      </div>
    </div>
  </form>

</mat-dialog-content>
